export const sampleEmails = [
  {
    id: 'email-1',
    subject: 'Urgent: Your Account Access Will Be Revoked',
    from: { 
      name: 'IT Support Team', 
      email: 'it-support@company-portal-secure.com' 
    },
    to: { 
      name: 'Employee', 
      email: 'employee@company.com' 
    },
    date: '2025-05-15T09:30:00Z',
    body: `
      <div style="font-family: Arial, sans-serif; color: #333;">
        <p>Dear Valued Employee,</p>
        
        <p><strong>URGENT: Your company account will be suspended in 24 hours!</strong></p>
        
        <p>Our security system has detected that your password has expired. You must verify your account immediately to maintain access to company resources.</p>
        
        <p><a href="https://malicious-website.com/login.php" style="color: #0066cc; text-decoration: underline;">Click here to update your credentials now</a></p>
        
        <p>Failure to update your credentials within 24 hours will result in immediate account suspension.</p>
        
        <p>Thank you for your immediate attention to this matter.</p>
        
        <p>Regards,<br>
        IT Support Team<br>
        Company Technical Department</p>
      </div>
    `,
    isPhishing: true,
    isRead: false,
    category: 'inbox',
    phishingIndicators: [
      {
        type: 'sender',
        title: 'Suspicious Sender Address',
        description: 'The email appears to be from "IT Support Team" but comes from a domain that is not your company\'s official domain. The real IT department would use your company\'s actual domain, not "company-portal-secure.com".'
      },
      {
        type: 'urgency',
        title: 'Artificial Urgency',
        description: 'The email creates a false sense of urgency with threats about account suspension to pressure you into taking immediate action without thinking.',
        text: 'URGENT: Your company account will be suspended in 24 hours!'
      },
      {
        type: 'link',
        title: 'Fraudulent Link',
        description: 'The link claims to take you to update your credentials but actually points to "malicious-website.com" which is not affiliated with your company.',
        text: 'Click here to update your credentials now',
        actualUrl: 'https://malicious-website.com/login.php',
        displayedUrl: 'Click here to update your credentials now'
      },
      {
        type: 'threat',
        title: 'Threatening Language',
        description: 'The email threatens negative consequences to create fear and prompt immediate action.',
        text: 'Failure to update your credentials within 24 hours will result in immediate account suspension.'
      }
    ]
  },
  {
    id: 'email-2',
    subject: 'Invoice #INV-2023-6745 for May Services',
    from: { 
      name: 'Accounting Department', 
      email: 'accounting@company.com' 
    },
    to: { 
      name: 'Employee', 
      email: 'employee@company.com' 
    },
    date: '2025-05-14T15:42:00Z',
    body: `
      <div style="font-family: Arial, sans-serif; color: #333;">
        <p>Hello,</p>
        
        <p>Please find attached the invoice #INV-2023-6745 for services rendered in May 2025.</p>
        
        <p>The payment is due on June 1, 2025. Please process it according to our standard procedures.</p>
        
        <p>If you have any questions about this invoice, don't hesitate to reach out to the accounting team.</p>
        
        <p>Best regards,<br>
        Sarah Johnson<br>
        Accounting Department<br>
        Company, Inc.</p>
      </div>
    `,
    attachments: [
      {
        name: 'INV-2023-6745.pdf',
        size: '256 KB',
        type: 'application/pdf'
      }
    ],
    isPhishing: false,
    isRead: true,
    category: 'inbox'
  },
  {
    id: 'email-3',
    subject: 'You have (1) Shared Document to Review',
    from: { 
      name: 'Microsoft OneDrive', 
      email: 'notification@onedrivefilesharing.com' 
    },
    to: { 
      name: 'Employee', 
      email: 'employee@company.com' 
    },
    date: '2025-05-15T10:17:00Z',
    body: `
      <div style="font-family: Arial, sans-serif; color: #333;">
        <div style="padding: 20px; border-bottom: 3px solid #0078d4;">
          <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/96/Microsoft_logo_%282012%29.svg/320px-Microsoft_logo_%282012%29.svg.png" alt="Microsoft" width="120" />
        </div>
        
        <div style="padding: 20px;">
          <p>Hello,</p>
          
          <p>You have received (1) secure document share</p>
          
          <p>John Williams (john.williams@client-company.com) has shared an important document with you titled "Project_Contract_2025.docx"</p>
          
          <p style="text-align: center; margin: 30px 0;">
            <a href="https://phishing-malware-site.com/download.php?id=12345" style="background-color: #0078d4; color: white; padding: 10px 20px; text-decoration: none; border-radius: 4px;">View Shared Document</a>
          </p>
          
          <p style="color: #666; font-size: 12px;">
            © 2025 Microsoft Corporation. All rights reserved.<br>
            Privacy Statement | Terms of Use
          </p>
        </div>
      </div>
    `,
    isPhishing: true,
    isRead: false,
    category: 'inbox',
    phishingIndicators: [
      {
        type: 'sender',
        title: 'Fake Sender Domain',
        description: 'While the display name is "Microsoft OneDrive", the actual email address uses "onedrivefilesharing.com" which is not a legitimate Microsoft domain. Real OneDrive notifications come from microsoft.com or related official domains.',
      },
      {
        type: 'link',
        title: 'Malicious Link',
        description: 'The "View Shared Document" button links to a malicious website "phishing-malware-site.com" instead of a legitimate Microsoft domain.',
        text: 'View Shared Document',
        actualUrl: 'https://phishing-malware-site.com/download.php?id=12345',
        displayedUrl: 'View Shared Document'
      },
      {
        type: 'branding',
        title: 'Microsoft Logo Misuse',
        description: 'The email uses Microsoft branding to appear legitimate, but the overall formatting doesn\'t match official Microsoft communications.'
      },
      {
        type: 'grammar',
        title: 'Unusual Phrasing',
        description: 'Phrases like "You have (1) secure document share" use awkward phrasing that wouldn\'t appear in legitimate Microsoft notifications.',
        text: 'You have (1) secure document share'
      }
    ]
  },
  {
    id: 'email-4',
    subject: 'Team Meeting Rescheduled: Updates to Project Timeline',
    from: { 
      name: 'Alex Rodriguez', 
      email: 'alex.rodriguez@company.com' 
    },
    to: { 
      name: 'Employee', 
      email: 'employee@company.com' 
    },
    date: '2025-05-14T18:24:00Z',
    body: `
      <div style="font-family: Arial, sans-serif; color: #333;">
        <p>Hi team,</p>
        
        <p>I'm writing to let you know that our weekly project meeting scheduled for tomorrow (May 16) has been moved to 2:30 PM instead of the usual 1:00 PM.</p>
        
        <p>We'll be discussing the updated timeline for Phase 2 of the project and addressing any concerns about the new deliverables. Please come prepared with your progress updates.</p>
        
        <p>The meeting link remains the same as our regular meetings. I've updated the calendar invitation, so you should see the change reflected in your calendars.</p>
        
        <p>Let me know if you have any questions.</p>
        
        <p>Thanks,<br>
        Alex</p>
      </div>
    `,
    isPhishing: false,
    isRead: true,
    category: 'inbox'
  },
  {
    id: 'email-5',
    subject: 'ALERT: Unusual Sign-in Activity Detected',
    from: { 
      name: 'Security Team', 
      email: 'noreply@security-alerts-center.org' 
    },
    to: { 
      name: 'Employee', 
      email: 'employee@company.com' 
    },
    date: '2025-05-15T07:12:00Z',
    body: `
      <div style="font-family: Arial, sans-serif; color: #333; padding: 20px; border: 1px solid #ddd;">
        <div style="text-align: center; margin-bottom: 20px;">
          <img src="https://via.placeholder.com/120x60?text=Security" alt="Security Alert" />
        </div>
        
        <p style="color: #cc0000; font-weight: bold; font-size: 18px;">⚠️ ALERT: Suspicious Sign-in Activity Detected</p>
        
        <p>Dear Valued Customer,</p>
        
        <p>Our security systems have detected an unusual sign-in attempt to your account from the following location:</p>
        
        <div style="background-color: #f5f5f5; padding: 10px; margin: 15px 0; border-left: 4px solid #cc0000;">
          <p><strong>Location:</strong> Moscow, Russia</p>
          <p><strong>IP Address:</strong> 82.144.XX.XX</p>
          <p><strong>Date/Time:</strong> May 15, 2025, 02:14 AM GMT</p>
          <p><strong>Device:</strong> Unknown Windows Device</p>
        </div>
        
        <p>If this wasn't you, your account may have been compromised. You must verify your identity immediately to secure your account.</p>
        
        <p style="text-align: center; margin: 25px 0;">
          <a href="https://secure-phishing-page.com/verify.html" style="background-color: #0056b3; color: white; padding: 12px 25px; text-decoration: none; font-weight: bold; border-radius: 4px;">SECURE MY ACCOUNT NOW</a>
        </p>
        
        <p><strong>Warning:</strong> If you do not verify your account within 24 hours, we will be forced to suspend your account for security reasons.</p>
        
        <p>Thank you for your cooperation in maintaining the security of your account.</p>
        
        <p>Sincerely,<br>
        The Security Team</p>
        
        <div style="font-size: 11px; color: #777; margin-top: 30px; padding-top: 10px; border-top: 1px solid #ddd;">
          <p>This is an automated security notification. Please do not reply to this email.</p>
        </div>
      </div>
    `,
    isPhishing: true,
    isRead: false,
    category: 'inbox',
    phishingIndicators: [
      {
        type: 'sender',
        title: 'Suspicious Domain',
        description: 'The sender domain "security-alerts-center.org" is not affiliated with your company. Legitimate security alerts would come from your company\'s official domain.',
      },
      {
        type: 'urgency',
        title: 'Artificial Urgency',
        description: 'The email creates a false sense of urgency by mentioning a 24-hour deadline before account suspension.',
        text: 'If you do not verify your account within 24 hours, we will be forced to suspend your account for security reasons.'
      },
      {
        type: 'fear',
        title: 'Fear Tactics',
        description: 'The email uses alarming language about account compromise and suspicious activity to trigger an emotional response.',
        text: '⚠️ ALERT: Suspicious Sign-in Activity Detected'
      },
      {
        type: 'link',
        title: 'Suspicious URL',
        description: 'The "SECURE MY ACCOUNT NOW" button links to "secure-phishing-page.com" which is not related to your company.',
        text: 'SECURE MY ACCOUNT NOW',
        actualUrl: 'https://secure-phishing-page.com/verify.html',
        displayedUrl: 'SECURE MY ACCOUNT NOW'
      },
      {
        type: 'generic',
        title: 'Generic Greeting',
        description: 'The email uses a generic greeting "Dear Valued Customer" rather than addressing you by name, which is unusual for legitimate company communications.',
        text: 'Dear Valued Customer,'
      }
    ]
  }
];

export default sampleEmails;